<div class="fan-news-card" [class.fan-news-card--v2]="design === 'v2'" [class.fan-news-card--popup]="design === 'popup'" *ngIf="stories?.length">
  <div class="fan-news-label" *ngIf="design === 'v1'">
    <span class="material-icons">newspaper</span>
    LATEST NEWS
  </div>
  <ng-container *ngIf="design === 'v2'">
    <div class="fan-news-head">
      <strong class="fan-news-heading">Latest from uReport</strong>
      <button type="button" class="fan-news-show" aria-haspopup="dialog" (click)="openList()">Show</button>
    </div>
    <div class="fan-news-source-line" *ngIf="sourceName"><i></i>{{ sourceName }} news source</div>
  </ng-container>

  <div class="fan-news-list" #list *ngIf="design !== 'v2'" [class.is-looping]="looping"
    (mouseenter)="setHovering(true)" (mouseleave)="setHovering(false)"
    (focusin)="setFocus($event)" (focusout)="setFocus(null)">
    <ng-container *ngFor="let story of stories; trackBy: trackById">
      <ng-container *ngTemplateOutlet="storyItem; context: { $implicit: story, copy: false }"></ng-container>
    </ng-container>
    <!-- Second copy for the seamless continuous loop; hidden from assistive tech and the tab order. -->
    <ng-container *ngIf="looping">
      <ng-container *ngFor="let story of stories; trackBy: trackById">
        <ng-container *ngTemplateOutlet="storyItem; context: { $implicit: story, copy: true }"></ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-template #storyItem let-story let-copy="copy">
  <button type="button" class="fan-news-item" [class.fan-news-item--copy]="copy"
    [attr.aria-hidden]="copy || null" [attr.tabindex]="copy ? -1 : null"
    (click)="openStory(story)" [attr.aria-label]="'Read: ' + story.title">
    <img *ngIf="story.imageUrl" class="fan-news-thumb" [src]="story.imageUrl" alt="" loading="lazy" />
    <span class="fan-news-text">
      <span class="fan-news-title">{{ story.title }}</span>
      <span class="fan-news-meta">
        <span *ngIf="metaLine(story)">{{ metaLine(story) }} · </span>{{ story.publishedAt | date: 'MMM d' }}
      </span>
      <span class="fan-news-source" *ngIf="story.sourceName">{{ story.sourceName }}</span>
    </span>
  </button>
</ng-template>
